import React, { useState, useEffect } from "react";
import { PathName } from "../utils/routes";
import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getResource } from "../redux/thunks/Resource";
import { isWhiteLabelClient } from "../utils/utilities";
import Button from "../components/sub-component/Button";
import { getAssessment } from "../redux/thunks/Assessment";
import ProcessingIndicator from "../components/common/ProcessingIndicator";
import { ReactComponent as TestFuseWatermarkIcon } from "../assets/icons/candidate-assessment/Watermark Light.svg";

function UnavailableAssessment({ assessmentData }) {
  const dispatch = useDispatch();
  const [icon, setIcon] = useState();
  const [isloading, setIsLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const assess_id = localStorage.getItem("assess_id");
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const assessment = useSelector((state) => state.assessmentReducer);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    window.location.replace(PathName.ASSESSMENTS);
    setProcessing(false);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    (async () => {
      if (assessmentData?.tenant?.image_id) {
        const imageResult = await dispatch(
          getResource({ id: assessmentData?.tenant?.image_id })
        );
        if (!imageResult.error) {
          setIcon(imageResult.payload.url);
        }
      } else {
        await dispatch(getAssessment({ id: assess_id }));
        if (assessment?.current_assessment?.tenant?.image_id) {
          const imageResult = await dispatch(
            getResource({
              id: assessment?.current_assessment?.tenant?.image_id,
            })
          );
          if (!imageResult.error) {
            setIcon(imageResult.payload.url);
          }
        }
      }
    })();
  }, [
    assessmentData?.tenant?.image_id,
    assess_id,
    assessment?.current_assessment?.tenant?.image_id,
  ]);

  return (
    <>
      {alert}
      {isloading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProcessingIndicator />
        </div>
      ) : (
        <div
          className="candidate-invite-main-container"
          style={{
            width: isOnMobileScreen ? "100%" : "calc(100% + 50px)",
            margin: isOnMobileScreen || !assessmentData ? "0px" : "-24px",
          }}
        >
          <div className="candidate-invite-container">
            {!isWhiteLabelClient() && (
              <div className="assessment-header">
                {icon ? (
                  <img className="assessment-header-icon" src={icon} alt="" />
                ) : (
                  <div className="assessment-header-icon-initial">
                    <span className="body-1 white">
                      {assessmentData?.tenant
                        ? (
                            assessmentData?.tenant?.company_name?.slice(0, 2) ||
                            ""
                          ).toUpperCase()
                        : (
                            assessment?.current_assessment?.tenant?.company_name?.slice(
                              0,
                              2
                            ) || ""
                          ).toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="headline-1 dark-100">
                  {assessmentData?.tenant
                    ? assessmentData?.tenant?.company_name
                    : assessment?.current_assessment?.tenant?.company_name}
                </span>
              </div>
            )}
            <span className="headline-3 text-start">
              Assessment Unavailable
            </span>
            <span className="body-2 dark-50 text-start">
              {`We're sorry, but the assessment you are trying to access is no
                longer available. This could be due to various reasons, such as
                the assessment period has ended or it has been withdrawn.`}
            </span>
            <span className="body-2 dark-50 text-start">
              If you have any questions or concerns, please feel free to contact
              our support team for assistance.
            </span>
            {!isWhiteLabelClient() && (
              <form className="w-100" onSubmit={handleSubmit}>
                <Button
                  btn="ragular-btn"
                  varrient="primary"
                  textClass="body-1"
                  processing={processing}
                  type={"submit"}
                  title={"Go To Dashboard"}
                  style={{ width: "100%", height: "40px" }}
                />
              </form>
            )}
          </div>
          {!isWhiteLabelClient() && (
            <div className="watermark mt-3">
              <TestFuseWatermarkIcon style={{ height: "50px" }} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default UnavailableAssessment;
